module.exports = __webpack_public_path__ + "img/banner-01.13138173.jpg";